import "./ServiceCTA.css";
import { Link } from "react-router-dom";
import { FaPhoneAlt, FaWhatsapp, FaArrowRight } from "react-icons/fa";
import useWebsiteSettings from "../../hooks/useWebsiteSettings";

const ServiceCTA = ({ data }) => {
  const { settings } = useWebsiteSettings();

  const whatsappNumber = settings?.whatsapp || settings?.phone || "9999999999";

  const phoneNumber = settings?.phone || "9999999999";

  const whatsappHref = `https://wa.me/${whatsappNumber.replace(/\D/g, "")}`;
  const phoneHref = `tel:${phoneNumber.replace(/\D/g, "")}`;

  return (
    <section className="service-cta">
      <div className="service-cta-overlay">
        <div className="service-cta-content">
          <span className="section-tag-cta">LET'S BUILD TOGETHER</span>

          <h2>{data?.cta?.title}</h2>

          <p>{data?.cta?.description}</p>

          <div className="cta-buttons">
            <Link to="/contact" className="primary-btn">
              Get Free Quote
              <FaArrowRight />
            </Link>

            <a
              href={whatsappHref}
              className="secondary-btn"
              target="_blank"
              rel="noreferrer"
              aria-label="Contact us on WhatsApp"
            >
              <FaWhatsapp />
              <span>WhatsApp</span>
            </a>

            <a href={phoneHref} className="secondary-btn" aria-label="Call us">
              <FaPhoneAlt />
              <span>Call Now</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceCTA;
